import React, { useState, useEffect } from 'react';
import { useTable } from 'react-table';
import Pagination from '../../../components/shared/pagination/index';
import { RiDeleteBin5Line, RiPencilLine } from "react-icons/ri";
import '../../../../src/index.css';
import { getProducts, deleteProductId, createProduct, updateProductId } from '../../../client/administration/products/index'; // Asegúrate de tener el método createProduct
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";
import { RiAddFill } from "react-icons/ri";
import { getProductsCategory } from '../../../client/administration/products/productCategory/index';
import AddData from '../../../components/shared/alertRegisterData/index';
import DeleteData from '../../shared/alertDeleteData/index';
import EditData from 'components/shared/alertEditData';
import InputField from 'components/forms/inputField';
import SelectField from 'components/forms/selectField';


const TableProduct = ({ recordsPerPage,  data, filterCategory,filterProduct,filterCode, currentPage, setCurrentPage, showModalAddProduct, closeModalAddProduct ,searchTerm, onSearchTermChange}) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModalAddData, setShowModalAddData] = useState(false);
  const [productCode, setProductCode] = useState('');
  const [productName, setProductName] = useState('');
  const [idCategory, setIdCategory] = useState('');
  const [showModalDeleteData, setShowModalDeleteData] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [showModalEditProduct, setShowModalEditProduct] = useState(null);
  
  const totalRecords = products.length;

  const [errors, setErrors] = useState({
      productCode: false,
      productName: false,
      idCategory: false, 
      categoryName: false,
  });

  const closeModalDeleteData = () => {
    setShowModalDeleteData(false);
  };
  const closeModalAddData = () => {
    setShowModalAddData(false);
  };

  // Obtener los productos
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const { data } = await getProducts();
        const filteredProducts = data
          .filter(product => {
            const matchesCategory = filterCategory 
              ? product.productCategory.categoryName.includes(filterCategory)
              : true;
            const matchesProduct = filterProduct 
              ? product.productName.toLowerCase().startsWith(filterProduct.toLowerCase()) 
              : true;
            const matchesCode = filterCode 
              ? product.codeProduct.toLowerCase().startsWith(filterCode.toLowerCase()) 
              : true;

            const matchesSearchTerm = searchTerm
              ? product.productCategory.categoryName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                product.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                product.codeProduct.toLowerCase().includes(searchTerm.toLowerCase())
              : true;
  
            return matchesCategory && matchesProduct && matchesCode && matchesSearchTerm;
          });
        setProducts(filteredProducts);
      } catch (err) {
        setError(err.message || "Error al cargar los productos");
      } finally {
        setLoading(false);
      }
    };
  
    fetchProducts();
  }, [filterCategory, filterProduct, filterCode, searchTerm]); 
  
  // Obtener las categorías
  const fetchCategories = async () => {
     try {
       const { data } = await getProductsCategory();
       setCategories(data);
     } catch (err) {
       setError(err.message || "Error al cargar las categorías");
     } finally {
       setLoading(false);
     }
   };

  useEffect(() => {
    fetchCategories(); 
  }, []);

  useEffect(() => {
    const filteredCategories = data.filter(category => 
    filterCategory ? category.productCategory.categoryName.includes(filterCategory) : true
    );
    
    setCategories(filteredCategories);
  }, [data, filterCategory]);
  
  const fetchProducts = async () => {
    try {
      const { data } = await getProducts();
      setProducts(data);
    } catch (err) {
      setError(err.message || "Error al cargar los productos");
    }
  };

  const handleSaveProduct = async () => {
    const newErrors = {
      codeProduct: !productCode || productCode.length < 3 || productCode.length > 45,
      productName: !productName || productName.length < 3 || productName.length > 45,
      idCategory: !idCategory,
    };

    setErrors(newErrors);
    // Si hay algún error, no continuar
    if (Object.values(newErrors).some(error => error)) {
      return;
    }
  
    const newProduct = {
      codeProduct: productCode,
      productName: productName,
      idCategory: idCategory, 
    };
  
    try {
      const { data } = await createProduct(newProduct);
      await fetchProducts();

      setProductCode('');
      setProductName('');
      setIdCategory('');
     // setShowModalAddProduct(false);
      closeModalAddProduct();
      setShowModalAddData(true);
  
      onSearchTermChange(searchTerm);
    } catch (err) {
    //  setError("Error al agregar el producto: " + err.message);
   //   alert("Hubo un error al agregar el producto.");
    }
  };
  
  const handleDeleteProduct = async () => {
    if (!productToDelete) return;
  
    try {
      await deleteProductId(productToDelete.id);
      setProducts(products.filter(product => product.id !== productToDelete.id));
      setProductToDelete(null); 
      setShowModalDeleteData(false); 
      
    } catch (err) {
      setError("Error al eliminar el producto: " + err.message);
      alert("Hubo un error al eliminar el producto.");
    }
  };
  const [editingProduct, setEditingProduct] = useState(null); 
  const [showEditConfirmModal, setShowEditConfirmModal] = useState(false);

  const openModalEditProduct = () => {
    setShowModalEditProduct(true);
  };

  const closeModalEditProduct = () => {
    setShowModalEditProduct(false);
  };

  const handleEditProductClick = (row) => {
    setEditingProduct(row);
    setEditedProduct({
      id: row.original.id,
      codeProduct: row.original.codeProduct,
      productName: row.original.productName,
      idCategory: row.original.idCategory,
    });
  };

  const handleProductInputChange = (e) => {
    const { name, value } = e.target;
    setEditedProduct((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleProductEditSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      codeProduct: !editedProduct.productCode || editedProduct.productCode.length < 3 || editedProduct.productCode.length > 45,
      productName: !editedProduct.productName || editedProduct.productName.length < 3 || editedProduct.productName.length > 45,
      idCategory: !editedProduct.idCategory,
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) {
        return;
    }
    setShowEditConfirmModal(true);
  };

  const [editedProduct, setEditedProduct] = useState({
    id: '',
    codeProduct: '',
    productName: '',
    idCategory: '',
  });

  const columns = React.useMemo(
    () => [
      {
        Header: '#',
        accessor: 'id',
        style: { width: '30px' },
        Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row.index + 1}</div>,
      },
      {
        Header: 'Producto',
        accessor: 'productName',
        style: { width: '260px' },
        Cell: ({ value }) => <div style={{ textAlign: 'center' }} >{value}</div>,
      },
      {
        Header: 'Código',
        accessor: 'codeProduct',
        style: { width: '139px' },
        Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value}</div>,
      },
      {
        Header: 'Categoría',
        accessor: 'productCategory.categoryName',
        style: { width: '274px' },
        Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value}</div>,
      },
      {
        Header: 'Fecha de Registro',
        accessor: 'createdAt',
        style: { width: '200px' },
        Cell: ({ value }) => (
          <div style={{ textAlign: 'center' }} >
            {new Date(value).toLocaleString()}
          </div>
        ),
      },
      {
        Header: 'Editar',
        accessor: 'editar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center " style={{textAlign: 'center'  }}>
            <button
               onClick={() => handleEditProductClick(row)}
              className="p-2 flex justify-center items-center bg-[#EFEEF7] hover:bg-[#D8D7E0] rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiPencilLine className="text-xl text-black" />
            </button>
          </div>
        ),
      },
      {
        Header: 'Eliminar',
        accessor: 'eliminar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center" style={{ textAlign: 'center'  }}>
            <button
              onClick={() => {
                setProductToDelete(row.original); // Pass the product to delete
                setShowModalDeleteData(true); // Show delete modal
              }}
              className="p-2 flex justify-center items-center bg-[#EFEEF7] hover:bg-[#D8D7E0]  rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiDeleteBin5Line className="text-xl text-black" />
            </button>
          </div>
        ),
      },
    ],
    [products]
  );

  /** PAGINACIÓN */
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const indexOfLastProduct = currentPage * recordsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - recordsPerPage;
  const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data: currentProducts });

 //if (loading) return <p>Cargando datos...</p>;
 if (error) {
  return (
    <div className='items-center justify-center w-full min-h-full pt-16'>
      <p className='pt-4 text-2xl text-center text-error font-itcmedium'>
        Hubo un error al recuperar los datos.
      </p>
    </div>
  );
}
  return (
    <div className="w-full pt-4">
      {/** 
      <div className=''>
        <button
          onClick={openModalAddProduct}
          className="flex items-center justify-center h-[40px] p-3 px-5 mb-4 space-x-4 text-white rounded-md bg-green"
          >
          <RiAddFill className="flex text-[14px] font-itcmedium" /> 
          Agregar producto
        </button>
      </div>
      */}
      {!error && products.length === 0 && (
        <div className='flex items-center justify-center w-full'>
         <p className='pt-4 text-xl text-center font-itcmedium'>No se hallaron registros.</p>
        </div>
      )}
      
      {/* Modal de editar producto */}
      {editingProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
          <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
              <button
                onClick={() => setEditingProduct(null)}
                className="px-1 py-0 rounded-md"
              >
                <img src={buttonClose} alt="Cerrar"/>
              </button>
            </div>
            <div className='flex flex-col items-center justify-center px-4 pb-4 space-y-4'>
              <div className='flex justify-center w-full'>
                <h1 className="mb-4 text-2xl font-bold text-blue font-itcbold">Editar Producto</h1>
              </div>
              <form onSubmit={handleProductEditSubmit} className='w-[85%] justify-center'>
              <div className='flex flex-col gap-4'>
                    <InputField
                      value={editedProduct.codeProduct}
                      placeholder="Código"
                      onChange={(e) =>
                        setEditedProduct((prevState) => ({
                          ...prevState,
                          codeProduct: e.target.value,
                        }))
                      }
                      error={errors.codeProduct}
                      errorMessage="Campo requerido"
                      minLength={3}
                      maxLength={45}
                      required
                    />

                    <InputField
                      value={editedProduct.productName}
                      placeholder="Nombre del Producto"
                      onChange={(e) =>
                        setEditedProduct((prevState) => ({
                          ...prevState,
                          productName: e.target.value,
                        }))
                      }
                      error={errors.productName}
                      errorMessage="Campo requerido"
                      minLength={3}
                      maxLength={45}
                      required
                    />

                    <SelectField
                      value={editedProduct.idCategory}
                      options={categories.map((category) => ({
                        value: category.id,
                        label: category.categoryName,
                      }))}
                      onChange={(e) =>
                        setEditedProduct((prevState) => ({
                          ...prevState,
                          idCategory: e.target.value,
                        }))
                      }
                      error={errors.idCategory}
                      errorMessage="Campo requerido"
                      required
                      placeholder="Categoría"
                    />
                </div>

                <div className="flex justify-between w-full gap-2 py-4 pt-8">
                  <button
                    type="submit"
                    className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi">
                    Guardar
                  </button> 
                  <button type="button"
                    onClick={() => setEditingProduct(null)}
                    className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                    Cancelar
                  </button>   
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showEditConfirmModal && (
        <EditData
          showModalEditData={showEditConfirmModal}
          closeModalEditData={() => setShowEditConfirmModal(false)}
          productName={editedProduct.productName}
          context="Producto"
          onConfirm={async () => {
            try {
              await updateProductId(editedProduct.id, {
                codeProduct: editedProduct.codeProduct,
                productName: editedProduct.productName,
                idCategory: editedProduct.idCategory,
              });
              const { data: updatedProducts } = await getProducts();
              setProducts(updatedProducts);
              setEditingProduct(null);
              setShowEditConfirmModal(false); 
            } catch (err) {
              setError("Error al actualizar el registro: " + err.message);
              alert("Hubo un error al intentar actualizar el registro.");
            }
          }}
        />
      )}

      {/* Modal de agregar producto */}
      {showModalAddProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
          <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
              <button
                onClick={closeModalAddProduct}
                className="px-1 py-0 rounded-md"
              >
                <img src={buttonClose} alt="Cerrar"/>
              </button>
            </div>
            <div className="flex flex-col items-center justify-center px-4 pb-4 space-y-4">
              <div className="flex justify-center w-full">
                <h1 className="mb-4 text-2xl text-blue font-itcbold">Agregar producto</h1>
              </div>

              <div className="justify-center flex flex-col gap-4 w-[85%]">
                  <InputField
                    value={productCode}
                    placeholder="Código"
                    onChange={(e) => {
                      setProductCode(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, codeProduct: false }));
                    }}
                    error={errors.codeProduct}
                    errorMessage= "Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />
                  <InputField
                    value={productName}
                    placeholder="Nombre del producto"
                    onChange={(e) => {
                      setProductName(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, productName: false }));
                    }}
                    error={errors.productName}
                    errorMessage= "Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />
                  <SelectField
                    value={idCategory}
                    options={categories.map((category) => ({
                      value: category.id,
                      label: category.categoryName
                    }))}
                    onChange={(e) => {
                      setIdCategory(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, idCategory: false }));
                    }}
                    error={errors.idCategory}
                    errorMessage="Campo requerido"
                    required
                    placeholder="Categoría"
                  />
              </div>
            </div>
            <div className="flex w-full py-4 sm:px-[7.5%] justify-between gap-2">
              <button 
                onClick={handleSaveProduct}
                className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi "
              >
                Guardar
              </button>
              <button
                onClick={closeModalAddProduct}
                className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de éxito */}
      <AddData showModalAddData={showModalAddData} closeModalAddData={closeModalAddData} />
  
      {/* Modal de eliminación */}
      {showModalDeleteData && (
        <DeleteData
          showModalDeleteData={showModalDeleteData}
          closeModalDeleteData={() => setShowModalDeleteData(false)}
          productName={productToDelete?.productName} 
          context="Producto"
          confirmDelete={handleDeleteProduct}
        />
      )}
      {!error && products.length > 0 && (
        <>
          {/* Tabla de productos */}
          <div className="max-w-full overflow-x-auto scroll-container">
            <table {...getTableProps()} className="w-full border-collapse table-fixed">
              <thead className="bg-white">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()} className="text-sm text-center font-itcbold">
                    {headerGroup.headers.map(column => (
                      <th
                        {...column.getHeaderProps()}
                        style={column.style}
                        className="px-4 py-2 border border-[#D9D9D9]"
                      >
                        {column.render('Header')}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="table-row-group">
                {rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className={`text-sm border-collapse h-full font-itcmedium text-left ${row.index % 2 === 0 ? 'bg-white' : 'bg-[#EBEBEB]/[0.2]'}`}
                    >
                      {row.cells.map(cell => (
                        <td
                          {...cell.getCellProps()}
                          style={cell.column.style}
                          className="px-4 py-2 border border-[#D9D9D9]"
                        >
                          {cell.render('Cell')}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="flex flex-col items-center justify-between mt-6 space-x-4 space-y-2 md:flex-row">
            <p className="text-[#1F2A37] text-sm font-itcbook">
              Mostrando registros del {(currentPage - 1) * recordsPerPage + 1} al{' '}
              {Math.min(currentPage * recordsPerPage, totalRecords)} de un total de {totalRecords} registros
            </p>
            <Pagination currentPage={currentPage} totalPages={totalPages} changePage={changePage} />
          </div>
        </>
      )}
    </div>
  );
};

export default TableProduct;
